module.exports = __webpack_public_path__ + "img/phonePe.17d69724.jpg";